export const CompanyTypeRouting = [
  {
    path: "/cooperation/company-type/list",
    name: "basic-cooperation-company-type-list",
    meta: { title: "往来单位类型管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company-type" */ "@/views/cooperation/company-type/list/index.vue"
      ),
  },
];
